<div class="clinic-item">
  <div class="clinic-item__wrapper">
    <h3 class="clinic-item__title">{{ title }}</h3>
    <h4 class="clinic-item__subtitle">
      {{ address }} {{ distance | distance }}
    </h4>
    <p class="clinic-item__description">{{ description }}</p>
  </div>
</div>
